import {ChevronIcon, PlusIcon} from './icons';
import Text from '@/components/react-native/text';
import TouchableOpacity from '@/components/react-native/touchable-opacity';
import View from '@/components/react-native/view';
import React from 'react';

export const SectionHeader = React.memo(
  ({
    title,
    isExpanded,
    onToggle,
    showAddButton = false,
    onAdd,
    backgroundColor = '#140034',
    textColor = '#E7E5E4'
  }: {
    title: string;
    isExpanded: boolean;
    onToggle: () => void;
    showAddButton?: boolean;
    onAdd?: () => void;
    backgroundColor?: string;
    textColor?: string;
  }) => (
    <TouchableOpacity
      onClick={onToggle}
      className="bg-[#000000] sticky top-0 z-10"
    >
      <View
        className="h-[52px] flex-row items-center justify-between px-[16px] py-[16px]"
        style={{backgroundColor}}
      >
        <View className="flex-row items-center gap-[3px]">
          <ChevronIcon direction={isExpanded ? 'down' : 'up'} color="#ffffff" />
          <Text
            fontFamily="GeistMono"
            className="text-[16px] font-[500] tracking-[-0.32px] uppercase"
            style={{color: textColor}}
          >
            {title}
          </Text>
        </View>

        {showAddButton && (
          <TouchableOpacity
            onClick={onAdd}
            className="flex-row items-center gap-[6px] px-[16px] py-[8px]"
          >
            <PlusIcon />
            <Text
              fontFamily="Geist"
              className="text-[#38BDF8] text-[16px] leading-[20px] font-[500] tracking-[-0.32px]"
            >
              Add Note
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </TouchableOpacity>
  )
);
SectionHeader.displayName = 'SectionHeader';
